import { atomWithStorage } from 'jotai/utils';

import { createSsrSafeStorage } from './ssrSafeStorage';

/**
 * After this many routine runs on web, show the desktop-app nurture banner
 * on Heidi Work (AGE-1455). Inclusive — matching the Evidence power-user banner.
 */
export const ROUTINES_DESKTOP_NURTURE_BANNER_COUNT_THRESHOLD = 10;

/** localStorage key — cleared on logout (`clearLogoutStorage`). */
export const ROUTINES_DESKTOP_NURTURE_BANNER_DISMISSED_STORAGE_KEY =
  'heidi.routinesDesktopNurtureBannerDismissed';

/**
 * Whether the user dismissed the Work routines → desktop nurture banner.
 * Persists across reloads; cleared on full logout so the next account is not suppressed.
 */
export const routinesDesktopNurtureBannerDismissedAtom = atomWithStorage<boolean>(
  ROUTINES_DESKTOP_NURTURE_BANNER_DISMISSED_STORAGE_KEY,
  false,
  createSsrSafeStorage<boolean>()
);
